import { createStore, applyMiddleware } from 'redux';
import { jwt } from '../middleware/jwt';
import thunk from 'redux-thunk';
import rootReducer from '../reducers';
import createSagaMiddleware from 'redux-saga';

export const sagaProdMiddleware = createSagaMiddleware();
export function configureProdStore(preloadedState) {
    return createStore(
        rootReducer,
        preloadedState,
        applyMiddleware(thunk, jwt, sagaProdMiddleware)
    );
}



// WEBPACK FOOTER //
// ./src/store/configureStore.prod.js